import { css } from '@emotion/react'
import styled from '@emotion/styled'

const itemStyles = ({ theme }) => css`
  width: 240px;

  ${theme.media.kilo} {
    width: 160px;
  }

  ${theme.media.giga} {
    width: 250px;
  }
`
export const WrapperItem = styled.div(itemStyles)
